import { withPathPrefix } from '../pathPrefix';
import { installBrowserWebpackShim } from './webpackShim';

installBrowserWebpackShim(() => withPathPrefix('/web/assets/'));
